<!-- src/views/pages/dashboard/index.vue -->
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="hasManageEmployees">
      <div class="row">
        <div class="col-xl-8">
          <Stat />
          <ApprovedTrainings />
          <TrainingSchedule />
        </div>
        <div class="col-xl-4">
          <EarningReport />
          <TrainingAnalytics />
          <RecentActivity />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-xl-12">
          <Stat />
          <MyTrainings />
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Stat from "./widget";
import EarningReport from "./earning";
import RecentActivity from "./recent-activity";
import ApprovedTrainings from "./approved-trainings";
import MyTrainings from "./my-trainings";
import TrainingSchedule from "./training-schedule";
import TrainingAnalytics from "./training-analytics";

export default {
  beforeRouteEnter(to, from, next) {
    next();
  },
  components: {
    Layout,
    PageHeader,
    Stat,
    EarningReport,
    MyTrainings,
    RecentActivity,
    ApprovedTrainings,
    TrainingSchedule,
    TrainingAnalytics
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Home"
        },
        {
          text: "Dashboard",
          active: true
        }
      ]
    };
  },
  computed: {
    user() {
      const loggedUser = this.$store.getters['auth/loggedInUser'];
      console.log("FROM INDEX ");
      console.log(loggedUser);
      return loggedUser ? loggedUser.user : null;
    },
    hasManageEmployees() {
      const user = this.$store.getters['auth/loggedInUser'];
      return user.permissions?.some(e => e.name === 'manage_employees') ?? false;
    },
  }
};
</script>